import { Event, IEvent } from "../Event";
import { IDIService } from "../IDIService";

export interface IPictureInPictureService extends IDIService {
	IsSupported(): boolean;
	RequestPictureInPictureAsync(): Promise<boolean>;
	OnEnteredPictureInPicture: IEvent;
	OnExitedPictureInPicture: IEvent;
}

export class PictureInPictureService implements IPictureInPictureService {
	public static readonly ServiceName: string = "PictureInPictureService";
	OnEnteredPictureInPicture: IEvent = new Event();
	OnExitedPictureInPicture: IEvent = new Event();
	private _nativeApi: IPictureInPictureService | null = null;

	public constructor() {
		if (this.IsSupported())
		{
			this._nativeApi = (navigator as any).pip as IPictureInPictureService;
			this._nativeApi?.OnEnteredPictureInPicture.Subscribe(() => (this.OnEnteredPictureInPicture as Event).Invoke());
			this._nativeApi?.OnExitedPictureInPicture.Subscribe(() => (this.OnExitedPictureInPicture as Event).Invoke());
		}
		else
			(navigator as any).pip = null;
	}

	IsSupported(): boolean {
		return (navigator as any).pip !== undefined && (navigator as any).pip !== null;
	}

	RequestPictureInPictureAsync(): Promise<boolean> {
		if (!this.IsSupported())
			return Promise.resolve(false);

		return this._nativeApi!.RequestPictureInPictureAsync();
	}

	GetServiceName(): string {
		return PictureInPictureService.ServiceName;
	}
}